export default __webpack_public_path__ + "static/city-background-right-a60907180759057a106fcd9eda0c4750.svg";